<template>
  <div style="position: relative;">
    <div class="content">
      <div class="list" v-for="(item,index) in invoiceList" :key="index">
        <div class="row-item" v-if="item.type == 'vat_invoice'" @click="edit(item, index)">
          <div class="item-name">增值税发票</div>
          <div class="item-sellName">销售方：{{ item.vatInvoice.sellerName }}</div>
          <div class="item-amount">价税合计：{{ item.vatInvoice.amountInFiguers }}</div>
          <div class="item-good">税目：{{ item.vatInvoiceDetails.length > 0 ? item.vatInvoiceDetails[0].name : '' }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'taxi_receipt'" @click="edit(item, index)">
          <div class="item-name">出租车票</div>
          <div class="item-sellName">发票代码：{{ item.taxiReceipt.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.taxiReceipt.invoiceNum }}</div>
          <div class="item-good">日期：{{ item.taxiReceipt.date }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'train_ticket'" @click="edit(item, index)">
          <div class="item-name">火车票</div>
          <div class="item-sellName">车票号：{{ item.trainTicket.ticketNum }}</div>
          <div class="item-amount">乘客姓名：{{ item.trainTicket.name }}</div>
          <div class="item-amount">身份证号：{{ item.trainTicket.idCard }}</div>
          <div class="item-good">出发日期：{{ item.trainTicket.date }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'quota_invoice'" @click="edit(item, index)">
          <div class="item-name">定额发票</div>
          <div class="item-sellName">发票代码：{{ item.quotaInvoice.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.quotaInvoice.invoiceNum }}</div>
          <div class="item-amount">金额：{{ item.quotaInvoice.invoiceRate }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'air_ticket'" @click="edit(item, index)">
          <div class="item-name">飞机行程单</div>
          <div class="item-sellName">姓名：{{ item.airTicket.name }}</div>
          <div class="item-amount">航班号：{{ item.airTicket.flight }}</div>
          <div class="item-amount">日期：{{ item.airTicket.date }}</div>
          <!--					<div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
        </div>
        <div class="row-item" v-if="item.type == 'roll_normal_invoice'" @click="edit(item, index)">
          <div class="item-name">卷票</div>
          <div class="item-sellName">销售方：{{ item.rollNormalInvoice.sellerName }}</div>
          <div class="item-amount">发票代码：{{ item.rollNormalInvoice.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.rollNormalInvoice.invoiceNum }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'printed_invoice'" @click="edit(item, index)">
          <div class="item-name">机打发票</div>
          <div class="item-sellName">销售方：{{ item.printedInvoice.sellerName }}</div>
          <div class="item-amount">发票代码：{{ item.printedInvoice.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.printedInvoice.invoiceNum }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'bus_ticket'" @click="edit(item, index)">
          <div class="item-name">汽车票</div>
          <div class="item-sellName">姓名：{{ item.busTicket.name }}</div>
          <div class="item-amount">发票代码：{{ item.busTicket.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.busTicket.invoiceNum }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'toll_invoice'" @click="edit(item, index)">
          <div class="item-name">过路过桥费</div>
          <div class="item-amount">发票代码：{{ item.tollInvoice.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.tollInvoice.invoiceNum }}</div>
          <div class="item-amount">日期：{{ item.tollInvoice.outDate }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'ferry_ticket'" @click="edit(item, index)">
          <div class="item-name">船票</div>
          <div class="item-amount">发票代码：{{ item.ferryTicket.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.ferryTicket.invoiceNum }}</div>
          <div class="item-amount">出发地点：{{ item.ferryTicket.exitStation }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'motor_vehicle_invoice'" @click="edit(item, index)">
          <div class="item-name">机动车销售发票</div>
          <div class="item-sellName">销售方：{{ item.motorVehicleInvoice.saler }}</div>
          <div class="item-amount">发票代码：{{ item.motorVehicleInvoice.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.motorVehicleInvoice.invoiceNum }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'used_vehicle_invoice'" @click="edit(item, index)">
          <div class="item-name">二手车销售发票</div>
          <div class="item-sellName">销售方：{{ item.usedVehicleInvoice.saler }}</div>
          <div class="item-amount">发票代码：{{ item.usedVehicleInvoice.invoiceCode }}</div>
          <div class="item-amount">发票号码：{{ item.usedVehicleInvoice.invoiceNum }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div class="row-item" v-if="item.type == 'taxi_online_ticket'" @click="edit(item, index)">
          <div class="item-name">网约车行程单</div>
          <div class="item-sellName">服务商：{{ item.taxiOnlineTicket.serviceProvider }}</div>
          <div class="item-amount">行程开始时间：{{ item.taxiOnlineTicket.startTime }}</div>
          <div class="item-amount">行程结束时间：{{ item.taxiOnlineTicket.destinationTime }}</div>
          <div class="item-amount">行程人手机号：{{ item.taxiOnlineTicket.phone }}</div>
          <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{ item.errorMsg }}</div>
        </div>
        <div @click="check(item)" v-if="item.code==200 && item.errorMsg == ''">
          <van-checkbox v-model="item.selected" shape="square"></van-checkbox>
        </div>
        <!--				<div v-if="item.code==200 && item.errorMsg.indexOf('发票重复') != -1">-->
        <!--					<image class="billstate" src="../../static/bill/ybx.png"></image>-->
        <!--				</div>-->
      </div>
    </div>

    <div style="position: fixed; bottom: 0; left: 0; width: 100%;">
      <van-button size="large" type="info" @click="saveBill" block>保存</van-button>
    </div>
  </div>
</template>

<script>
import InvoiceService from '@/api/invoice/InvoiceService.js' ;

export default {
  name: 'invoiceList',
  data() {
    return {
      invoiceList: [],
      invoices: [],
    }
  },
  created() {
    this.invoiceList = JSON.parse(localStorage.getItem('results'));
  },
  activated() {
    this.invoiceList = JSON.parse(localStorage.getItem('results'));
  },
  methods: {
    check(item) {
      if (item.selected) {
        item.selected = false;
      } else {
        item.selected = true;
      }
    },
    saveBill() {
      this.invoices = [];
      for (let i = 0; i < this.invoiceList.length; i++) {
        let d = this.invoiceList[i];
        if (d.selected) {
          this.invoices[this.invoices.length] = d;
        }
      }
      if (this.invoices.length == 0) {
        this.$toast.fail('请选择要保存的发票信息');
        this.invoices = [];
        return;
      }
      let _this = this;
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确定保存吗？',
      }).then(() => {
        _this.$toast.loading({message: '正在提交...', forbidClick: true});
        let inputForm = {invoices: JSON.stringify(_this.invoices)}
        new InvoiceService().saveBill(inputForm).then(({data}) => {
          if(data.code === 200) {
            _this.$toast.success('保存成功');
            setTimeout(() => {
              this.$router.push({
                path: '/invoice'
              })
            }, 800)
          } else {
            let errMsg = '';
            if (data && data.msg) {
              errMsg = '：' + data.msg
            }
            _this.$toast.fail('请检查发票信息是否有异常' + errMsg);
          }
        })
      }).catch(() => {
      });
    },
    edit(item, index) {
      if(item.errorMsg) {
        return
      }
      switch (item.type) {
        case 'vat_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.vatInvoice)),
              type: item.type,
              billDetails: encodeURIComponent(JSON.stringify(item.vatInvoiceDetails)),
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
            }
          })
          break;
        case 'taxi_receipt':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.taxiReceipt)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'train_ticket':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.trainTicket)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'quota_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.quotaInvoice)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'air_ticket':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.airTicket)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'roll_normal_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.rollNormalInvoice)),
              billDetails: encodeURIComponent(JSON.stringify(item.rollNormalInvoiceDetails)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'printed_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.printedInvoice)),
              billDetails: encodeURIComponent(JSON.stringify(item.printedInvoiceDetails)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'bus_ticket':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.busTicket)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'toll_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.tollInvoice)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'ferry_ticket':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.ferryTicket)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'motor_vehicle_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.motorVehicleInvoice)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'used_vehicle_invoice':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.usedVehicleInvoice)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              method: 'edit'
              // billDetails: encodeURIComponent(JSON.stringify(item.taxiReceiptDetails))
            }
          })
          break;
        case 'taxi_online_ticket':
          this.$router.push({
            path: '/invoiceInfo',
            query: {
              data: encodeURIComponent(JSON.stringify(item.taxiOnlineTicket)),
              type: item.type,
              result: encodeURIComponent(JSON.stringify(this.invoiceList)),
              index: index,
              billDetails: encodeURIComponent(JSON.stringify(item.items)),
              method: 'edit'
            }
          })
          break;
      }
    }
  }
}
</script>

<style scoped>
page {
  background-color: #FFFFFF;
}

.content {
  padding-bottom: 80px;
}

.input {
  width: 97%;
  margin: 5px auto;
  padding-left: 10px;
  border: 1px solid #EEEEEE;
}

.list {
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #EEEEEE;
}

.row-item {
  width: 85%;
  padding: 5px 5px 8px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.item-name {
  width: 280px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #e29700;
}

.item-sellName {
  width: 280px;
  font-size: 11px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.item-amount {
  font-size: 11px;
  display: block;
  color: #4D4D4D;
}

.item-good {
  font-size: 11px;
  display: block;
  margin-top: 3px;
  color: #4D4D4D;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.item-errorMsg {
  font-size: 11px;
  display: block;
  margin-top: 3px;
  color: #eb5e4b;
}

.billstate {
  margin-right: 20px;
  width: 64px;
  height: 64px;
}
</style>
